import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { ReactComponent as WelcomeChatIcon } from '../../resources/images/welcome-chat.svg';
import Shadow from '../../resources/images/shadow.svg';
import { COLOR_WHITE } from '../utilities/MaterialWatchman';
import { PrimaryButton } from '../utilities/commonUtilities/GenericButtonElements';
import { styleBreakMobile } from '../utilities/layouts/Globals';

const useStyles = makeStyles(theme => ({
    welcomeChatContainer: {
        padding: theme.spacing(3),
        paddingTop: theme.spacing(8.25),
        paddingBottom: theme.spacing(7.6),
        [styleBreakMobile(theme)]: {
            maxHeight: '100vh',
        },
    },
    careTeamInfoContainer: {
        backgroundColor: theme.palette.primary.light,
        height: theme.spacing(39.375),
        padding: `${theme.spacing(4.5)}px ${theme.spacing(3)}px`,
    },
    shadow: {
        '& svg': {
            height: theme.spacing(3),
            width: theme.spacing(21),
        },
    },
    infoParagraph: {
        fontSize: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'center',
        '&:last-child': {
            marginBottom: 0,
        },
    },
    infoHeader: {
        textAlign: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(3),
        fontSize: theme.spacing(3.75),
        fontWeight: 700,
    },
    careTeamItem: {
        textAlign: 'center',
        marginBottom: theme.spacing(2.5),
    },
    profession: {
        fontWeight: 400,
        fontSize: theme.spacing(2),
    },
    careTeamName: {
        fontSize: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    acknowledgeWelcomeButtonContainer: {
        backgroundColor: COLOR_WHITE,
        padding: theme.spacing(3),
    },
    acknowledgeWelcomeButton: {
        width: '100%',
    },
}));

// TODO: move this array to redux store when it's attached to Patient
const careTeam = [];

function CareTeamItem({ item }) {
    const classes = useStyles();
    return (
        <Box className={classes.careTeamItem}>
            <Typography className={classes.careTeamName} variant="h4">{item.name}</Typography>
            <Typography className={classes.profession} variant="h4">{item.profession}</Typography>
        </Box>
    )
}

function CareTeam() {
    const classes = useStyles();
    return (
        <Box className={classes.careTeamInfoContainer}>
            <Typography variant="h2" className={classes.infoHeader}>
                Your Care Team
            </Typography>
            {
                careTeam.map((c, idx) => <CareTeamItem key={idx} item={c} />)
            }
        </Box>
    )
}

const ChatWelcomePage = ({ onAccept }) => {
    const classes = useStyles();

    return (
        <>
            <Box className={classes.welcomeChatContainer}>
                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                    <WelcomeChatIcon />
                    <img src={Shadow} alt="shadow" className={classes.shadow} />
                </Box>
                <Typography variant="h2" className={classes.infoHeader}>
                    Welcome to Chat
                </Typography>
                <Box>
                    <Typography variant="body1" className={classes.infoParagraph}>
                        Use this chat to securely share text and images with your care team!
                    </Typography>

                    <Typography variant="body1" className={classes.infoParagraph}>
                        There is no guaranteed response time when communicating with your care team. Consult your user manual for more information.
                    </Typography>

                    <Typography variant="body1" className={classes.infoParagraph}>
                        If you have, or suspect you are experiencing a health emergency, call 911 and/or promptly visit a Hospital Emergency Department in your area
                    </Typography>
                </Box>
            </Box>
            { (careTeam?.length > 0) && <CareTeam/> }
            <Box className={classes.acknowledgeWelcomeButtonContainer}>
                <PrimaryButton onClick={() => onAccept(true)} className={classes.acknowledgeWelcomeButton}>
                    Got it!
                </PrimaryButton>
            </Box>
        </>
    );
}

export default ChatWelcomePage;